import { useEffect, useState } from 'react';

export default function useDeferredUnmount(
  visible: boolean,
  exitDurationMs: number,
): boolean {
  const [shouldRender, setShouldRender] = useState(visible);

  useEffect(() => {
    if (visible) {
      setShouldRender(true);
      return;
    }
    const timer = setTimeout(() => setShouldRender(false), exitDurationMs);
    return () => clearTimeout(timer);
  }, [visible, exitDurationMs]);

  return shouldRender;
}
